import React from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCardFooter,
  CButton,
  CLabel,
  CDataTable,
  CBadge,
} from "@coreui/react";

import * as Constants from "./constants";
import * as Status from "constants/statusBooking";
import Item from "./components/Item";

function ReservationForm({
  reservation,
  onSave,
  onCancel,
  onEditItem,
  back,
  cancel,
  check,
  big,
}) {
  const mapAssistants = () =>
    reservation.assistants.map(
      ({ name, lastName, typeId, numberId, id, state, first }) => ({
        id,
        [Constants.NAME]: `${name} ${lastName}`,
        [Constants.CC]: `${typeId} ${numberId}`,
        state,
        first,
      })
    );
  const validateSuccess = () => {
    let valid = false;
    let BreakException = {};
    try {
      if (reservation.assistants) {
        reservation.assistants.forEach(function (el) {
          if (el.state === Status.PENDING) throw BreakException;
        });
      }
    } catch (e) {
      valid = true;
      if (e !== BreakException) throw e;
    }
    return valid;
  };

  const getColorTicket = (ticket) =>
    ticket === "vip"
      ? "success"
      : ticket === "preferencial"
      ? "primary"
      : "info";

  return (
    <CCard>
      <CCardHeader>
        {back && (
          <CButton
            variant="outline"
            color="dark"
            onClick={onCancel}
            style={{ marginRight: "20px" }}
          >
            Regresar
          </CButton>
        )}
        {big ? (
          <b>
            <h3>{reservation.eventInfo}</h3>
          </b>
        ) : (
          <CLabel>{reservation.eventInfo}</CLabel>
        )}
      </CCardHeader>
      <CCardBody>
        {reservation.ticket && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              columnGap: 8,
            }}
          >
            Ticket:
            <CBadge
              style={{
                height: 24,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: 8,
                paddingLeft: 8
              }}
              size={36}
              color={getColorTicket(reservation.ticket)}
            >
              {reservation.ticket.toUpperCase()}
            </CBadge>
          </div>
        )}
        <CDataTable
          items={mapAssistants()}
          fields={check ? Constants.CheckFields : Constants.Fields}
          itemsPerPage={5}
          scopedSlots={{
            [Constants.OPTIONS]: (item) => (
              <td>
                <Item onEditItem={onEditItem} {...item} />
              </td>
            ),
            [Constants.CHECK]: (item) => (
              <td>
                <Item onEditItem={onEditItem} {...item} check />
              </td>
            ),
            [Constants.NAME]: (item) => (
              <td>
                <CLabel style={{ marginRight: "5px" }}>{`${
                  item[Constants.NAME]
                }`}</CLabel>
                {item.first === "si" && <CBadge color="success">Nuevo</CBadge>}
              </td>
            ),
          }}
        />
      </CCardBody>
      <CCardFooter>
        <CButton
          color="success"
          onClick={onSave}
          style={{ marginRight: "20px" }}
          disabled={!validateSuccess()}
        >
          Guardar cambios
        </CButton>
        {cancel && (
          <CButton color="danger" onClick={onCancel}>
            Regresar
          </CButton>
        )}
      </CCardFooter>
    </CCard>
  );
}

export default ReservationForm;
